export function getEncodedOrigin(): string {
  const origin = getOrigin()
  return encodeURIComponent(origin)
}

export function getOrigin(): string {
  return `${process.env.PUBLIC_URL || window.location.origin}/`
}
